export default __webpack_public_path__ + "static/media/logo-webpay-plus-blanik-660x312.8e3decb5.png";